import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'

const AlertDialog = ({
  title,
  message,
  okButton,
  cancelButton,
  onOk,
  cancelLabel,
  okLabel,
  onCancel,
  isOpen,
  onClose,
}) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      {cancelButton ||
        (onCancel && (
          <Button onClick={onCancel} color="primary" aria-label={cancelLabel}>
            {cancelLabel}
          </Button>
        ))}
      {okButton ||
        (onOk && (
          <Button onClick={onOk} color="primary" autoFocus aria-label={okLabel}>
            {okLabel}
          </Button>
        ))}
    </DialogActions>
  </Dialog>
)

AlertDialog.defaultProps = {
  title: '',
  message: 'Message',
  okButton: null,
  cancelButton: null,
  onOk: null,
  cancelLabel: 'Cancel',
  okLabel: 'Ok',
  onCancel: null,
  isOpen: false,
  onClose: () => {},
}
export default AlertDialog
